import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import DisclaimerForm from '../DisclaimerForm';

function DisclaimerEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <DisclaimerForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </DisclaimerForm>
    </Edit>
  );
}

export default DisclaimerEdit;
